import { render } from "./tempInStore.vue?vue&type=template&id=fa1a71c4&scoped=true"
import script from "./tempInStore.vue?vue&type=script&lang=js"
export * from "./tempInStore.vue?vue&type=script&lang=js"

import "./tempInStore.vue?vue&type=style&index=0&id=fa1a71c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1a71c4"]])

export default __exports__